import React, { PropsWithChildren } from "react"
import styled from "styled-components";

export interface IconProps {
  color?: string;
  size?: string;
  width?: string;
  height?: string;
  viewBox?: string;
  isClicked?: boolean;
}

export const StyledSvg = styled("svg")<IconProps>`
  width: ${({width}) => width ? width : "1em"};
  height: ${({height}) => height ? height : "1em"};
  flex-shrink: 0;
  line-height: 1em;
  fill: currentColor;
  color: ${({color}) => color};
`;

export const Icon = ({
  color = "inherit",
  viewBox = "0 0 32 32",
  width,
  height,
  size,
  isClicked,
  ...rest
}: PropsWithChildren<IconProps>): JSX.Element => {
  return (
    <StyledSvg viewBox={viewBox} {...rest} color={color} width={size ? size : width} height={size ? size : height} isClicked />
  )
}

export const WhiskymofoGoldIcon = (props: IconProps) => (
  <Icon {...props} viewBox="0 0 134 40">
    <path d="M131.495 0L134 2.50549V37.419L131.495 39.9245H125.067L122.562 37.419V2.50549L125.067 0H131.495ZM128.989 35.1858V4.73865H127.573V35.1858H128.989Z" fill="#F3B659"/>
    <path d="M112.149 0H121.191V4.73865H117.16V16.3946H121.191V21.1333H117.16V39.9245H112.149V0Z" fill="#F3B659"/>
    <path d="M108.01 0L110.515 2.50549V37.419L108.01 39.9245H101.583L99.0772 37.419V2.50549L101.583 0H108.01ZM105.504 35.1858V4.73865H104.088V35.1858H105.504Z" fill="#F3B659"/>
    <path d="M97.4351 0V39.9245H92.4241V17.5384L90.3544 28.0506H88.2846L86.2693 17.5384V39.9245H81.803V0H87.3587L89.8642 14.4338L91.8794 0H97.4351Z" fill="#F3B659"/>
    <path d="M77.0085 39.9245H71.9976V21.6235L67.8036 0H72.8146L74.6665 11.6015L76.5728 0H81.1481L77.0085 21.6235V39.9245Z" fill="#F3B659"/>
    <path d="M68.2571 39.9245H63.1372L59.9781 22.7128V39.9245H54.9671V0H59.9781V14.7061L62.538 0H67.4401L64.0631 17.7563L68.2571 39.9245Z" fill="#F3B659"/>
    <path d="M53.3332 37.419L50.8277 39.9245H44.4005L41.8951 37.419V22.7673H46.906V35.1858H48.3222V22.5494L41.8951 17.2116V2.50549L44.4005 0H50.8277L53.3332 2.50549V13.0177H48.3222V4.73865H46.906V13.9436L53.3332 19.2269V37.419Z" fill="#F3B659"/>
    <path d="M40.2701 39.9245H35.2591V0H40.2701V39.9245Z" fill="#F3B659"/>
    <path d="M28.6141 0H33.625V39.9245H28.6141V21.1333H27.1979V39.9245H22.1869V0H27.1979V16.3946H28.6141V0Z" fill="#F3B659"/>
    <path d="M13.1266 0L14.924 25.2183L16.7759 0H21.3512L17.8652 39.9245H12.0917L10.6756 20.9699L9.20496 39.9245H3.43144L0 0H5.01098L6.8084 25.2183L8.66029 0H13.1266Z" fill="#F3B659"/>
  </Icon>
);

export const WhiskymofoBlackIcon = (props: IconProps) => (
  <Icon {...props} viewBox="0 0 248 74">
    <path d="M242.578 0L247.2 4.62207V69.0296L242.578 73.6517H230.721L226.099 69.0296V4.62207L230.721 0H242.578ZM237.956 64.91V8.74174H235.343V64.91H237.956Z" fill="#292928"/>
    <path d="M206.89 0H223.57V8.74174H216.135V30.2444H223.57V38.9862H216.135V73.6517H206.89V0Z" fill="#292928"/>
    <path d="M199.254 0L203.876 4.62207V69.0296L199.254 73.6517H187.397L182.775 69.0296V4.62207L187.397 0H199.254ZM194.632 64.91V8.74174H192.019V64.91H194.632Z" fill="#292928"/>
    <path d="M179.746 0V73.6517H170.502V32.3545L166.683 51.7471H162.865L159.147 32.3545V73.6517H150.908V0H161.157L165.779 26.6271L169.497 0H179.746Z" fill="#292928"/>
    <path d="M142.064 73.6517H132.819V39.8905L125.082 0H134.327L137.743 21.4022L141.26 0H149.7L142.064 39.8905V73.6517Z" fill="#292928"/>
    <path d="M125.919 73.6517H116.474L110.646 41.9001V73.6517H101.402V0H110.646V27.1296L115.369 0H124.412L118.182 32.7564L125.919 73.6517Z" fill="#292928"/>
    <path d="M98.3879 69.0296L93.7658 73.6517H81.9092L77.2871 69.0296V42.0006H86.5312V64.91H89.1437V41.5986L77.2871 31.7516V4.62207L81.9092 0H93.7658L98.3879 4.62207V24.0147H89.1437V8.74174H86.5312V25.7228L98.3879 35.4694V69.0296Z" fill="#292928"/>
    <path d="M74.2892 73.6517H65.045V0H74.2892V73.6517Z" fill="#292928"/>
    <path d="M52.7864 0H62.0306V73.6517H52.7864V38.9862H50.174V73.6517H40.9298V0H50.174V30.2444H52.7864V0Z" fill="#292928"/>
    <path d="M24.2156 0L27.5315 46.5222L30.9478 0H39.3881L32.9574 73.6517H22.3065L19.694 38.6847L16.9811 73.6517H6.33023L0 0H9.24414L12.56 46.5222L15.9763 0H24.2156Z" fill="#292928"/>
  </Icon>
);

export const LockIcon = (props: IconProps) => (
  <Icon {...props} viewBox="0 0 24 24">
    <g clip-path="url(#clip0_56_989)">
    <path d="M12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17ZM18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM8.9 6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8H8.9V6ZM18 20H6V10H18V20Z" fill="#323232"/>
    </g>
    <defs>
    <clipPath id="clip0_56_989">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
  </Icon>
);
